import segment from 'src/js/modules/analytics/segment';

const {
  constants: { events, triggerIds },
  trackers: { trackEvent },
} = segment;

const trackEditingViewBreakpointSwitched = ({ breakpointType }) => {
  trackEvent(events.EDITING_VIEW_BREAKPOINT_SWITCHED, {
    breakpointType,
    triggerId: triggerIds.ELEMENT_SETTINGS,
  });
};

export default trackEditingViewBreakpointSwitched;
